// # #############################################
// # Title : Pricing Details
// # Authors : Dhruv, Shubham, Atul
// # Date : 15th October 2019
// # Last Modified : Dhruv, October 2019 : Rearranged components based on latest mock made by Smit -
// #                 (https://xd.adobe.com/spec/dc0f4f52-fd43-42a8-5693-e3efbb7b61d5-aa3e/screen/beeb7f7c-2293-43a5-b449-fb60e3734ff0/Product-2/)
// # Version : 19.10.03
// # Description : This is the code for the create product component
// # ############################################

// Import Required Libraries

import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import '../css/ProductWidget2.css';
import StarRatings from 'react-star-ratings';
import GlobalEvents from '../utils/global-events';
import Checkbox from './Checkbox';
import HorizontalBarChart from './HorizontalBarChart';
// import CircularProgress from "@material-ui/core/CircularProgress";
import * as helperFunctions from "../utils/helperFunction";
import ReactTooltip from "react-tooltip";
import { Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import ConsumerSegmentsDialogue from './ConsumerSegmentsInfo'

import '../css/Dialogue.css'

const styles = theme => ({})

// const config = require('../utils/config');

var loading = false;

function convertRange(value, r1, r2) {
    return (value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0];
}

let chartColors = ['#344955'];

const names_base = { // Addons for every beverage category
    water: {
        addons: [
            "spring",
            "electrolytes",
            "carbonated"
        ]
    },
    milk: {
        addons: [
            "probiotic",
            "vegan",
            "no_preservative",
            "natural_flavour",
            "sugar_free",
            "skimmed",
            "artificial_flavour"
        ]
    },
    coffee: {
        addons: [
            "sugar_free",
            "organic",
            "caffeine_free",
            "no_preservative",
            "natural_flavour",
            "artificial_flavour",
            "carbonated",
            "herbal_extracts",
            "anti_oxidants"

        ]
    },
    tea: {
        addons: [
            "sugar_free",
            "organic",
            "natural_flavour",
            "artificial_flavour",
            "carbonated",
            "herbal_extracts",
            "anti_oxidants",
            "caffeine_free"

        ]
    },
    carbonation: {
        addons: [
            "sugar_free",
            "natural_flavour",
            "artificial_flavour",
            "added_vitamins",
            "zero_calorie",
            "extra_caffiene"

        ]
    },
    fruit: {
        addons: [
            "sugar_free",
            "organic",
            "no_preservative",
            "natural_flavour",
            "artificial_flavour",
            "added_pulp"
        ]
    }
}

var product_configs = { // Indexes for every beverage category
    "water": {
        "health": "3",
        "taste": "2",
        "pleasure": "2",
        "visual": "6",
        "price": "0.01"
    },
    "milk": {
        "health": "1",
        "taste": "5",
        "pleasure": "6",
        "visual": "6",
        "price": "0.06"
    },
    "tea": {
        "health": "2",
        "taste": "5",
        "pleasure": "5",
        "visual": "6",
        "price": "0.02"
    },
    "coffee": {
        "health": "2",
        "taste": "4",
        "pleasure": "6",
        "visual": "6",
        "price": "0.1"
    },
    "fruit": {
        "health": "2",
        "taste": "4",
        "pleasure": "4",
        "visual": "6",
        "price": "0.05"
    },
    "carbonation": {
        "health": "1.5",
        "taste": "3",
        "pleasure": "3",
        "visual": "3",
        "price": "0.04"
    },
    "natural_flavour": {
        "health": "1",
        "taste": "1",
        "pleasure": "1",
        "visual": "1",
        "price": "0.01"
    },
    "artificial_flavour": {
        "health": "-1",
        "taste": "1",
        "pleasure": "1",
        "visual": "2",
        "price": "0.005"
    },
    "sugar_free": {
        "health": "2",
        "taste": "-2",
        "pleasure": "-3",
        "visual": "0",
        "price": "0.01"
    },
    "organic": {
        "health": "2",
        "taste": "1",
        "pleasure": "0",
        "visual": "0",
        "price": "0.02"
    },
    "probiotic": {
        "health": "2",
        "taste": "0",
        "pleasure": "0",
        "visual": "0",
        "price": "0.015"
    },
    "caffeine_free": {
        "health": "1",
        "taste": "-1",
        "pleasure": "-2",
        "visual": "0",
        "price": "0.01"
    },
    "no_preservative": {
        "health": "1",
        "taste": "0",
        "pleasure": "0",
        "visual": "0",
        "price": "0.05"
    },
    "none": {
        "health": "0",
        "taste": "0",
        "pleasure": "0",
        "visual": "0",
        "price": "0"
    },
    "spring": {
        "health": "1",
        "taste": "2",
        "pleasure": "0",
        "visual": "0",
        "price": "0.015"
    },
    "electrolytes": {
        "health": "2",
        "taste": "1",
        "pleasure": "0",
        "visual": "0",
        "price": "0.01"
    },
    "carbonated": {
        "health": "1",
        "taste": "2",
        "pleasure": "2",
        "visual": "2",
        "price": "0.02"
    },
    "added_pulp": {
        "health": "2",
        "taste": "2",
        "pleasure": "0",
        "visual": "2",
        "price": "0.01"
    },
    "herbal_extracts": {
        "health": "0.5",
        "taste": "-0.5",
        "pleasure": "0",
        "visual": "0",
        "price": "0.03"
    },
    "anti_oxidants": {
        "health": "0.5",
        "taste": "0",
        "pleasure": "0",
        "visual": "0",
        "price": "0.04"
    },
    "vegan": {
        "health": "1",
        "taste": "-1",
        "pleasure": "-1",
        "visual": "0",
        "price": "0.03"
    },
    "skimmed": {
        "health": "2",
        "taste": "-2",
        "pleasure": "-2",
        "visual": "0",
        "price": "0.01"
    },
    "zero_calorie": {
        "health": "2",
        "taste": "-2",
        "pleasure": "-1",
        "visual": "0",
        "price": "0.01"
    },
    "added_vitamins": {
        "health": "1",
        "taste": "0",
        "pleasure": "0",
        "visual": "0",
        "price": "0.02"
    },
    "extra_caffiene": {
        "health": "2",
        "taste": "2",
        "pleasure": "2",
        "visual": "0",
        "price": "0.015"
    }
}

class ProductWidget extends Component {
    constructor(props) {
        super(props)
        // this.slide = this.slide.bind(this);
        this.state = { // default state
            width: "md",
            height: 0,
            selectedSegment: '',
            open: false,
            category_selected: 'coffee',
            addons_selected: [],
            product_image: 'coffee.svg',
            drinkingMomentData: [{
                name: 'Time Out At Work/School',
                y: 61.41,
            }, {
                name: 'Comforting Meals at Home',
                y: 25.84
            }, {
                name: 'Relaxing Screen Time',
                y: 11.67
            }],
            segmentData: [{
                name: 'Jumbo Families',
                y: 9.35,
            }, {
                name: 'Active Elders',
                y: 9.27
            }, {
                name: 'Fortunes & Families',
                y: 7.93
            }],
            categoryPercentage: '12.5%',
            volume: '9.5',
            checkboxes: names_base['coffee']['addons'].reduce(
                (options, option) => ({
                    ...options,
                    [option]: false
                }),
                {}
            )
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    selectAllCheckboxes = isSelected => { // Save the checkbox state with previous checkbox state
        Object.keys(this.state.checkboxes).forEach(checkbox => {
            this.setState(prevState => ({
                checkboxes: {
                    ...prevState.checkboxes,
                    [checkbox]: isSelected
                }
            }));
        });
    };

    selectAll = () => this.selectAllCheckboxes(true); // Select All Checkboxes

    deselectAll = () => this.selectAllCheckboxes(false); // Deselect All Checkboxes

    handleCheckboxChange = changeEvent => { // Get the selected checkbox
        const { name } = changeEvent.target;

        this.setState(prevState => ({
            checkboxes: {
                ...prevState.checkboxes,
                [name]: !prevState.checkboxes[name]
            }
        }));

        this.storeProductDetails.bind(this)
    };

    handleFormSubmit = formSubmitEvent => { // Submit the form 
        formSubmitEvent.preventDefault();

        Object.keys(this.state.checkboxes)
            .filter(checkbox => this.state.checkboxes[checkbox])
    };

    createCheckbox = option => ( // Create a Check Box
        <Checkbox
            label={option}
            isSelected={this.state.checkboxes[option]}
            onCheckboxChange={this.handleCheckboxChange}
            type='addon'
            key={option}
            ref={option}
            productClass="product-form"
        />
    );

    createCheckboxes = () => names_base[this.state.category_selected]['addons'].map(this.createCheckbox); // Create check boxes for all addons

    changeProps(el, type) { // Change the beverage category
        this.deselectAll();
        const types = ["water", "milk", "coffee", "tea", "carbonation", "fruit"];
        this.refs[`${el}_div`].style.borderBottom = '1.5px solid #344955';
        this.refs[`${el}_div`].style.backgroundImage = "linear-gradient(white, #c6eff5)";
        types.filter(function (ele) {
            return ele !== el;
        }).forEach(elem => {
            this.refs[`${elem}_div`].style.borderBottom = '1.5px solid rgba(0,0,0,0)';
            this.refs[`${elem}_div`].style.backgroundImage = "linear-gradient(white, white)";
        })
        this.setState({
            category_selected: el,
            addons_selected: names_base[el]['addons']
        })

        if (el === 'tea') {
            this.setState({
                drinkingMomentData:
                    [{
                        name: 'Time Out At Work/School',
                        y: 61.41,
                    }, {
                        name: 'Nourishing Breakfast',
                        y: 25.84
                    }, {
                        name: 'Nurturing Meals at home',
                        y: 11.67
                    }],
                segmentData:
                    [{
                        name: 'Leisure Buffs',
                        y: 12.46,
                    }, {
                        name: 'Active Elders',
                        y: 11.55
                    }, {
                        name: 'Fortunes & Families',
                        y: 7.18
                    }],
                categoryPercentage: '6.7%',
                volume: '16.9',
                product_image: 'cup.svg'
            })
        } else if (el === 'coffee') {
            this.setState({
                drinkingMomentData: [{
                    name: 'Time Out At Work/School',
                    y: 61.41,
                }, {
                    name: 'Comforting Meals at Home',
                    y: 25.84
                }, {
                    name: 'Relaxing Screen Time',
                    y: 11.67
                }],
                segmentData:
                    [{
                        name: 'Jumbo Families',
                        y: 9.35,
                    }, {
                        name: 'Active Elders',
                        y: 9.27
                    }, {
                        name: 'Fortunes & Families',
                        y: 7.93
                    }],
                categoryPercentage: '12.5%',
                volume: '9.5',
                product_image: 'coffee.svg'

            })
        } else if (el === 'fruit') {
            this.setState({
                drinkingMomentData:
                    [{
                        name: 'Relaxing Screen Time',
                        y: 61.41,
                    }, {
                        name: 'Routine Habits at Home',
                        y: 25.84
                    }, {
                        name: 'Time Out At Work/School',
                        y: 11.67
                    }],
                segmentData:
                    [{
                        name: 'Active Elders',
                        y: 9.77,
                    }, {
                        name: 'Leisure Buffs',
                        y: 8.28
                    }, {
                        name: 'Flush Families',
                        y: 7.65
                    }],
                categoryPercentage: '5.4%',
                volume: '10',
                product_image: 'pineapple-juice.svg'
            })
        } else if (el === 'milk') {
            this.setState({
                drinkingMomentData:
                    [{
                        name: 'Nourishing Breakfast',
                        y: 61.41,
                    }, {
                        name: 'Nurturing Meals at home',
                        y: 25.84
                    }, {
                        name: 'Energizing Breakfast',
                        y: 11.67
                    }],
                segmentData:
                    [{
                        name: 'Leisure Buffs',
                        y: 9.41
                    }, {
                        name: 'Flush Families',
                        y: 8.23
                    }, {
                        name: 'Modest Means',
                        y: 7.17
                    }],
                categoryPercentage: '10%',
                volume: '8',
                product_image: 'milk1.svg'
            })
        } else if (el === 'carbonation') {
            this.setState({
                drinkingMomentData:
                    [{
                        name: 'Relaxing Screen Time',
                        y: 61.41,
                    }, {
                        name: 'Energy on the Run',
                        y: 25.84
                    }, {
                        name: 'Mental Refreshment at home',
                        y: 11.67
                    }],
                segmentData:
                    [{
                        name: 'Leisure Buffs',
                        y: 8.91
                    }, {
                        name: 'Active Elders',
                        y: 8.47
                    }, {
                        name: 'Flush Families',
                        y: 7.5
                    }],
                categoryPercentage: '26.3%',
                volume: '12',
                product_image: 'soft-drink1.svg'
            })
        } else if (el === 'water') {
            this.setState({
                drinkingMomentData:
                    [{
                        name: 'Routine Habits at Home',
                        y: 61.41,
                    }, {
                        name: 'Daily Unwind',
                        y: 25.84
                    }, {
                        name: 'Physical Recovery',
                        y: 11.67
                    }],
                segmentData:
                    [{
                        name: 'Active Elders',
                        y: 9.39
                    }, {
                        name: 'Leisure Buffs',
                        y: 8.53
                    }, {
                        name: 'Jumbo Families',
                        y: 6.71
                    }],
                categoryPercentage: '25%',
                volume: '16.9',
                product_image: 'water1.svg'
            })
        }

    }

    storeProductDetails() {

        let manf_cost = parseFloat(product_configs[this.state.category_selected]["price"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
            return this.state.checkboxes[d]
        }).reduce(function (acc, val) {
            return acc + parseFloat(product_configs[val]["price"]);
        }, 0));

        manf_cost = manf_cost * parseFloat(this.state.volume);

        sessionStorage.setItem('productData', JSON.stringify({
            "product_data": {
                "category": this.state.category_selected,
                "addons": Object.keys(this.state.checkboxes).filter(d => {
                    return this.state.checkboxes[d]
                }),
                "health": parseFloat(product_configs[this.state.category_selected]["health"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                    return this.state.checkboxes[d]
                }).reduce(function (acc, val) {
                    return acc + parseFloat(product_configs[val]["health"]);
                }, 0)),
                "taste": parseFloat(product_configs[this.state.category_selected]["taste"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                    return this.state.checkboxes[d]
                }).reduce(function (acc, val) {
                    return acc + parseFloat(product_configs[val]["taste"]);
                }, 0)),
                "pleasure": parseFloat(product_configs[this.state.category_selected]["pleasure"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                    return this.state.checkboxes[d]
                }).reduce(function (acc, val) {
                    return acc + parseFloat(product_configs[val]["pleasure"]);
                }, 0)),
                "visual": parseFloat(product_configs[this.state.category_selected]["visual"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                    return this.state.checkboxes[d]
                }).reduce(function (acc, val) {
                    return acc + parseFloat(product_configs[val]["visual"]);
                }, 0)),
                "product_image": this.state.product_image
            },
            "manufacturing_cost": `$${manf_cost}`,
            "clientId": `${sessionStorage.getItem('ClientId')}`
        }));


        sessionStorage.setItem('pricingData', JSON.stringify({
            "cost_to_customer": `$${((parseFloat(1) + parseFloat(manf_cost)) + Math.ceil((parseFloat(1) + parseFloat(manf_cost)) * 0.3)).toFixed(2)}`,
            "manufacturing_cost": `$${manf_cost}`,
            "profit_margin": `${Math.ceil((1) * 100 / (manf_cost))}`
        }))
    }

    componentDidMount() {

        window.addEventListener('resize', this.updateWindowDimensions);
        GlobalEvents.on('storeProductDetails', this.storeProductDetails.bind(this));

        const prod_data = JSON.parse(JSON.parse(JSON.stringify(sessionStorage.getItem('productData'))));

        if (prod_data) {
            try{
                this.refs[`${prod_data.product_data.category}_div`].click()
                setTimeout(()=>{                    
                    prod_data.product_data.addons.forEach(d => {
                        console.log('productwidget',d)
                        document.getElementById(`${d}_addon`).click();
                    }); 
                },1)   
            }
            catch(e){}            
        }

        loading = false
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    updateWindowDimensions() {

        if (window.innerWidth < 1200) {
            this.setState({ width: "sm" });
        }

        else if (window.innerWidth >= 1200) {
            this.setState({ width: "md" });
        }

    }

    render() { // Self Explanatory


        if (sessionStorage.getItem('simStarted') === 'true') {
            if (this.refs.submit) {
                this.refs['submit'].style.background = '#c1c1c1';
                this.refs['submit'].style.pointerEvents = 'none';
                this.refs['ProductWidget'].style.pointerEvents = 'none';
            }
        }

        if (loading === false) {

            let manf_cost = parseFloat(product_configs[this.state.category_selected]["price"]) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                return this.state.checkboxes[d]
            }).reduce(function (acc, val) {
                return acc + parseFloat(product_configs[val]["price"]);
            }, 0));

            manf_cost = manf_cost * parseFloat(this.state.volume);

            let category_selected = this.state.category_selected;

            if (category_selected === "fruit") {
                category_selected = "Juice"
            }
            else if (category_selected === "carbonation") {
                category_selected = "SE Drink"
            }

            return (
                <React.Fragment>
                    <div className="productView">
                        <div className="categories categoriesWidth">
                            <div className="card_element" ref="tea_div" title={"Tea ($0.5)"} onClick={this.changeProps.bind(this, "tea")}>
                                <img className="tea" src="tea.svg" alt="Avatar" />
                                <div className="text_container"> Tea </div>
                            </div>
                            <div className="card_element" ref="coffee_div" title={"Coffee ($0.35)"} onClick={this.changeProps.bind(this, "coffee")} style={{ borderBottom: "1px solid #344955", backgroundImage: "linear-gradient(white, #c6eff5)" }}  >
                                <img className="coffee" src="coffee-mug.svg" alt="Avatar" />
                                <div className="text_container"> Coffee </div>
                            </div>
                            <div className="card_element" ref="fruit_div" title={"Fruit Juice ($0.56)"} onClick={this.changeProps.bind(this, "fruit")}>
                                <img className="juice" src="juice.svg" alt="Avatar" />
                                <div className="text_container"> Juice </div>
                            </div>
                            <div className="card_element" ref="milk_div" title={"Milk ($1.35)"} onClick={this.changeProps.bind(this, "milk")}>
                                <img className="milk" src="milk.svg" alt="Avatar" />
                                <div className="text_container"> Milk </div>
                            </div>
                            <div className="card_element" ref="carbonation_div" title={"Soft/Energy Drinks ($0.08)"} onClick={this.changeProps.bind(this, "carbonation")} >
                                <img className="softDrink" src="soft-drink.svg" alt="Avatar" />
                                <div className="text_container"> Soft/Energy Drink </div>
                            </div>
                            <div className="card_element" ref="water_div" title={"Water ($0.15)"} onClick={this.changeProps.bind(this, "water")}>
                                <img className="water" src="water.svg" alt="Avatar" />
                                <div className="text_container"> Water </div>
                            </div>
                        </div>
                        <div class="row">
                            {/*Static graphs pannel - Left ------------------------------------------------------------------------------------------------*/}
                            <div className="graphs">
                                <div className="graph1">
                                    <div id={"header_element"} > <strong>Market Share for {category_selected} </strong>- {this.state.categoryPercentage}</div>
                                    <div className="content-header" style={{ display: "flex", justifyContent: "space-between", flexDirection: 'row', }}>
                                        <div style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>{`Top 3 Consumer Segments for ${helperFunctions.convertToTitleCase(category_selected)}`}</div>
                                        {<div style={{ height: '90%' }}>
                                            <Tooltip placement="top" title="Click to view info about various customer segments" >
                                                <InfoOutlinedIcon onClick={this.handleClickOpen} style={{ padding: '0px 10px', cursor: "pointer", height: '90%' }} color="disabled" />
                                            </Tooltip>
                                            <ConsumerSegmentsDialogue
                                                open={this.state.open}
                                                onClose={this.handleClose}
                                                maxWidth={this.state.width}
                                                handleClose={this.handleClose}
                                            />
                                        </div>}
                                    </div>
                                    <div className="graph-content">
                                        <HorizontalBarChart color="white" key="consumer_segments" data={this.state.segmentData || [{
                                            name: 'Others',
                                            y: 73.45
                                        }, {
                                            name: 'Jumbo Families',
                                            y: 9.35,
                                        }, {
                                            name: 'Active Elders',
                                            y: 9.27
                                        }, {
                                            name: 'Fortunes & Families',
                                            y: 7.93
                                        }]} colors={chartColors}
                                            tooltip={true} yTitle={"Percentage"} label={"{y}%"} />
                                    </div>
                                </div>
                                <div className="graph2">
                                    <div className="content-header"> {`Top 3 Drinking Moments for ${helperFunctions.convertToTitleCase(category_selected)}`} </div>
                                    <div className="graph-content">
                                        <HorizontalBarChart color="white" key="drinking_moments" data={this.state.drinkingMomentData || [{
                                            name: 'Time Out At Work/School',
                                            y: 61.41,
                                        }, {
                                            name: 'Comforting Meals at Home',
                                            y: 25.84
                                        }, {
                                            name: 'Relaxing Screen Time',
                                            y: 11.67
                                        }, {
                                            name: 'Others',
                                            y: 4.67
                                        }]} colors={chartColors}
                                            tooltip={true} yTitle={"Percentage"} label={"{y}%"} />
                                    </div>
                                </div>
                            </div>
                            {/*Choose Addons and Star rating pannel - Right ------------------------------------------------------------------------------------------------*/}
                            <div className="levers">
                                <div className="checkboxes-container">
                                    <div id={"header_element"} > <strong>Quantity</strong> : {this.state.volume} fl oz</div>
                                    <div className="content-header"> Choose Addons </div>
                                    <div className="checkboxes">
                                        {this.createCheckboxes()}
                                    </div>
                                </div>
                                <div className="selectionInfo">
                                    <div className="stats-part">
                                        <div className="stats-label">
                                            <div className="stats-percentage">
                                                ${manf_cost.toFixed(2)}
                                            </div>
                                            Product manufacturing Cost
                                            </div>
                                    </div>
                                    {/* </div> */}
                                    <div className="ratingstars">
                                        <ReactTooltip
                                            class='rating'
                                            id='rating'
                                            getContent={dataTip => (
                                                <div className="tooltip-style">
                                                    These star ratings change based on the addon selected. <br /><br /> <b>Example:</b> Selecting "No Added Sugar" reduces rating for Taste and increases rating for Health
                                                </div>
                                            )}
                                            effect='solid'
                                            place={"top"}
                                            border={true}
                                            type={"light"}
                                        />
                                        <div className="StarRatingsWrapper" >
                                            <table data-tip data-for='rating' className="tableClass" bgcolor="#ebe72d" style={{ textAlign: "left" }}>
                                                <tbody>
                                                    <tr className="StarRatings">
                                                        <td className="rating-label" >Health</td>
                                                        <td><StarRatings rating={
                                                            convertRange(parseFloat(product_configs[this.state.category_selected]['health']) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                                                                return this.state.checkboxes[d]
                                                            }).reduce(function (acc, val) {
                                                                return acc + parseFloat(product_configs[val]['health']);
                                                            }, 0)), [0, 10], [0, 5])
                                                        } starRatedColor="#3ca0b0" starEmptyColor="#c1c1c1" starDimension="1.3rem"
                                                            starSpacing="0.1vw" /></td>
                                                    </tr>
                                                    <tr className="StarRatings">
                                                        <td className="rating-label">Taste</td>
                                                        <td><StarRatings
                                                            rating={convertRange(parseFloat(product_configs[this.state.category_selected]['taste']) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                                                                return this.state.checkboxes[d]
                                                            }).reduce(function (acc, val) {
                                                                return acc + parseFloat(product_configs[val]['taste']);
                                                            }, 0)), [0, 10], [0, 5])} starRatedColor="#3ca0b0" starEmptyColor="#c1c1c1"
                                                            starDimension="1.3rem"
                                                            starSpacing="0.1vw" /></td>
                                                    </tr>
                                                    <tr className="StarRatings">
                                                        <td className="rating-label">Pleasure</td>
                                                        <td><StarRatings
                                                            rating={convertRange(parseFloat(product_configs[this.state.category_selected]['pleasure']) + parseFloat(Object.keys(this.state.checkboxes).filter(d => {
                                                                return this.state.checkboxes[d]
                                                            }).reduce(function (acc, val) {
                                                                return acc + parseFloat(product_configs[val]['pleasure']);
                                                            }, 0)), [0, 10], [0, 5])} starRatedColor="#3ca0b0" starEmptyColor="#c1c1c1"
                                                            starDimension="1.3rem"
                                                            starSpacing="0.1vw" /></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        else {
            return (
                <div className='graphLoader'>
                    <div id={"loaderContainer"}>
                        <div class="lds-facebook"><div></div><div></div><div></div></div>
                    </div>
                </div>
            );
        }
    }
}

ProductWidget.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired
}

export default withStyles(styles)(ProductWidget);
